import requests from "./httpService";

const CustomerServices = {
  createCustomer(storeId, customerData) {
    return requests.post(`/api/stores/${storeId}/customers`, customerData);
  },

  getAllCustomers(storeId) {
    return requests.get(`/api/stores/${storeId}/customers`);
  },

  getCustomerByPhone(storeId, phone){
    console.log("🚀 ~ getCustomerByPhone ~ phone:", phone)
    return requests.get(`/api/stores/${storeId}/customers/getCustomerByPhone/${phone}`);
  },

  updateCustomer(storeId, customerId, customerData) {
    return requests.put(
      `/api/stores/${storeId}/customers/${customerId}`,
      customerData
    );
  },

  deleteCustomer(storeId, customerId) {
    return requests.delete(`/api/stores/${storeId}/customers/${customerId}`);
  },
};

export default CustomerServices;
